import { render, staticRenderFns } from "./v2.vue?vue&type=template&id=bddf72de&scoped=true"
import script from "./v2.vue?vue&type=script&lang=js"
export * from "./v2.vue?vue&type=script&lang=js"
import style0 from "./v2.vue?vue&type=style&index=0&id=bddf72de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bddf72de",
  null
  
)

export default component.exports